export default __webpack_public_path__ + "static/media/background-4.42742277.png";